import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BidReportQuery,
  UpdateBidReportPublicityMutation,
  UpdateBidReportPublicityMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const updateBidReportPublicity = graphql(`
  mutation updateBidReportPublicity($input: UpdateBidReportPublicityRequest!) {
    updateBidReportPublicity(UpdateBidReportPublicityRequest: $input) {
      id
      publicHash
    }
  }
`);

export function useUpdateBidReportPublicity(
  options?: UseMutationOptions<
    UpdateBidReportPublicityMutation,
    unknown,
    UpdateBidReportPublicityMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(updateBidReportPublicity, {
    ...options,
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
      queryClient.setQueryData(
        ["bidReport", data.updateBidReportPublicity.id],
        (prevData: BidReportQuery | undefined) => {
          if (!prevData) return prevData;
          return {
            bidReport: {
              ...prevData.bidReport,
              publicHash: data.updateBidReportPublicity.publicHash,
            },
          };
        },
      );
    },
  });
  return { data: data?.updateBidReportPublicity, ...rest };
}
